export const mapOptions: google.maps.MapOptions = {
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    gestureHandling: 'cooperative',
    minZoom: 1,
    maxZoom: 22,
};
